import {
    Link as ChakraLink,
    Text,
    Input,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    Image, 
    Heading, 
    Badge,
    Avatar,
    Tabs,
    TabList,
    Tab,
    Flex,
    TabIndicator,
    Spacer,
    Box,
    Center, 
    useToast,
    VStack,
    HStack,
    Tooltip,
    IconButton,
    Divider,
    Checkbox
  } from '@chakra-ui/react'

import { useRouter } from 'next/router'
import {IoSettings,IoCart, IoHelpCircle, IoReceipt, IoEarth,IoExit, IoBarChart, IoBriefcase, IoAlarm, IoHandLeft, IoPerson, IoMail,IoInformationCircle, IoCheckmarkDoneCircleSharp, IoCash,IoCheckmarkCircle, IoDownload ,IoCloudUpload,IoSave,IoDocumentAttachOutline , IoPersonAdd, IoAddCircle, IoShare,IoTrash, IoPersonCircleSharp, IoTimer, IoLockClosed, IoCloseCircle, IoGlobe, IoCopy, IoRibbon, IoCaretForward, IoChevronForward, IoChevronBack, IoBusiness, IoSwapHorizontal, IoBulb, IoHome, IoGrid, IoNotifications} from 'react-icons/io5';

import ReactGA from 'react-ga4'; ReactGA.initialize('G-0GRPP85B5D');

import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { resolve } from 'path';
import { motion, AnimatePresence } from 'framer-motion';
import InviteUserModal from './InviteUserModal';
import { round } from 'lodash';
import TutorialModal from './TutorialModal';
import TeamSwitcherDropdown from './TeamSwitcherDropdown';
import Countdown from 'react-countdown';


import { useTranslation } from 'next-i18next'
import { withInvoiceQueueConsumerTarget } from "../utils/url";

// Renderer callback with condition
const rendererTimer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <div />;
  } else {
    // Render a countdown
    return <span>{minutes} min. {seconds} sec.</span>;
  }
};

const MenuElement = ({sessionData, openInvoice, onUpgradeOpen }) => {

    const {t} = useTranslation('common')
  
    const { isOpen: isUserOpne, onOpen: onUserOpen, onClose: onUserClose } = useDisclosure();

    const { isOpen: isTutorialOpen, onOpen: onTutorialOpen, onClose: onTutorialClose } = useDisclosure()
    const { isOpen: isInviteUserOpen, onOpen: onInviteUserOpen, onClose: onInviteUserClose } = useDisclosure()
    
    const router = useRouter();
    const newUserAllDataAdded = false;
    const { isOpen, onOpen, onClose } = useDisclosure()

    const [uploadInProgress, setUploadInProgress] = useState(false);

    const elementRef = useRef(null);

    const api_url = process.env.NEXT_PUBLIC_API_URL
    const toast = useToast()

    const [tabIndex, setTabIndex] = useState(0);
    const [tabArray, setTabArray] = useState([])
    const [pendingSuggestionsCount, setPendingSuggestionsCount] = useState(0);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
    const [isSignupDiscountVisible, setIsSignupDiscountVisible] = useState(true);

    // Profile modal (draft editing)
    const [isProfileSaving, setIsProfileSaving] = useState(false);
    const [isProfileLoading, setIsProfileLoading] = useState(false);
    const [profileMe, setProfileMe] = useState<{ user_data?: any; team_data?: any } | null>(null);
    type NotificationSettingsV2 = {
      channels: { inApp: boolean; email: boolean };
      events: Array<{
        key: string;
        label?: string;
        description?: string;
        channels: { inApp: boolean; email: boolean };
      }>;
    };
    const [profileDraft, setProfileDraft] = useState<{
      username: string;
      profilePicture: string;
      profilePictureSignedUrl?: string;
      notificationSettingsKey: string | null;
      notificationSettings: NotificationSettingsV2 | null;
    }>({
      username: "",
      profilePicture: "",
      profilePictureSignedUrl: "",
      notificationSettingsKey: null,
      notificationSettings: null,
    });
    const [profileOriginal, setProfileOriginal] = useState<{
      username: string;
      profilePicture: string;
      profilePictureSignedUrl?: string;
      notificationSettingsKey: string | null;
      notificationSettings: NotificationSettingsV2 | null;
    } | null>(null);
    const [profileOverride, setProfileOverride] = useState<{
      username?: string;
      profilePicture?: string;
      profilePictureSignedUrl?: string;
    }>({});

    const navigateToTab = async (pageName)=>{ 
      router.push(pageName);
    }

    const isActiveRoute = (route: string) => {
      if (router.pathname === route) return true;
      // Treat settings sub-pages (e.g. /settings/integrations/...) as part of /settings
      if (route === "/settings" && router.pathname.startsWith("/settings/")) return true;
      return false;
    }

    const userNotification = async (title, subTitle, status) => {
      toast({
        title: title,
        description: subTitle,
        status: status,
        duration: 5000,
        isClosable: true,
        position: 'bottom-left',
      })
    }
    const ProfilePictureUploadRef = useRef(null);

    const normalizeNotificationSettingsV2 = (val: any): NotificationSettingsV2 | null => {
      if (!val || typeof val !== "object") return null;
      const channels = (val as any).channels;
      const events = (val as any).events;
      if (!channels || typeof channels !== "object") return null;
      if (typeof channels.inApp !== "boolean" || typeof channels.email !== "boolean") return null;
      if (!Array.isArray(events)) return null;
      return {
        channels: { inApp: !!channels.inApp, email: !!channels.email },
        events: events
          .filter((e: any) => e && typeof e === "object" && typeof e.key === "string")
          .map((e: any) => ({
            key: String(e.key),
            label: e.label != null ? String(e.label) : undefined,
            description: e.description != null ? String(e.description) : undefined,
            channels: {
              inApp: !!(e.channels && typeof e.channels === "object" ? e.channels.inApp : false),
              email: !!(e.channels && typeof e.channels === "object" ? e.channels.email : false),
            },
          })),
      };
    };

    const detectNotificationSettings = (user: any): { key: string | null; settings: NotificationSettingsV2 | null } => {
      if (!user || typeof user !== "object") return { key: null, settings: null };
      const candidates = [
        "notificationSettings",
        "notificationPreferences",
        "notificationsSettings",
        "notificationsPreferences",
      ];
      for (const key of candidates) {
        const val = (user as any)[key];
        const normalized = normalizeNotificationSettingsV2(val);
        if (normalized) return { key, settings: normalized };
      }
      return { key: null, settings: null };
    };

    const openProfileModal = () => {
      // Open immediately for snappy UX, then load fresh data via /users/me
      onUserOpen();
      const fallbackUser = sessionData?.user_data || {};
      const fallbackDetected = detectNotificationSettings(fallbackUser);
      const fallbackDraft = {
        username: String((fallbackUser as any)?.username || ""),
        profilePicture: String((fallbackUser as any)?.profilePicture || ""),
        profilePictureSignedUrl: String(
          (fallbackUser as any)?.profilePictureSignedUrl ||
            (fallbackUser as any)?.profilePicture ||
            ""
        ),
        notificationSettingsKey: fallbackDetected.key,
        notificationSettings: fallbackDetected.settings,
      };
      setProfileMe({ user_data: fallbackUser, team_data: sessionData?.team_data });
      setProfileOriginal(fallbackDraft);
      setProfileDraft(fallbackDraft);

      if (!sessionData?.accessToken) return;
      (async () => {
        setIsProfileLoading(true);
        try {
          const res = await fetch(`${api_url}/users/me`, {
            headers: { 'Authorization': `Bearer ${sessionData.accessToken}` },
          });
          if (!res.ok) {
            let msg = `Failed to load profile (${res.status})`;
            try {
              const j = await res.json();
              if (j?.message) msg = Array.isArray(j.message) ? j.message.join(", ") : String(j.message);
              else if (j?.error) msg = String(j.error);
            } catch (e) {}
            userNotification("Error", msg, "error");
            return;
          }

          const me = await res.json();
          const user = me?.user_data || {};
          const team = me?.team_data || sessionData?.team_data;
          setProfileMe({ user_data: user, team_data: team });

          const detected = detectNotificationSettings(user);
          const draft = {
            username: String((user as any)?.username || ""),
            profilePicture: String((user as any)?.profilePicture || ""),
            profilePictureSignedUrl: String(
              (user as any)?.profilePictureSignedUrl ||
                (user as any)?.profilePicture ||
                ""
            ),
            notificationSettingsKey: detected.key,
            notificationSettings: detected.settings,
          };
          setProfileOriginal(draft);
          setProfileDraft(draft);
        } catch (e: any) {
          userNotification("Error", "Network error while loading profile.", "error");
        } finally {
          setIsProfileLoading(false);
        }
      })();
    };

    const uploadProPic = async (data: File, returnOnlyData = false) => {
      if(returnOnlyData == false){
        setUploadInProgress(true)
      }
      var formData = new FormData();
      formData.append('file', data)
      const fetchData = await fetch(withInvoiceQueueConsumerTarget(`${api_url}/files/upload/?disableAi=true`), {
        headers: {
          'Authorization': `Bearer ${sessionData.accessToken}`,
        },
        credentials: "include",
        method: "Post",
        body: formData
      })
      const response = await fetchData.json();
      if(response.statusCode == 400 || response.statusCode == 500){
        userNotification("Upload error", "Only PDF, PNG & JPG are allowed", "error");
        setUploadInProgress(false);
        return;
      }
      if(response && typeof response === "object" && "imageUrl" in response){
        const imageURL = String((response as any).imageUrl || "");
        const imageURLSigned = String((response as any).imageUrlSigned || imageURL);
        setProfileDraft(prev => ({
          ...prev,
          profilePicture: imageURL,
          profilePictureSignedUrl: imageURLSigned,
        }));

        const userId = profileMe?.user_data?._id || sessionData?.user_data?._id;
        if (!userId) {
          userNotification(
            "Upload warning",
            "Image uploaded, but could not save it to your profile. Please reopen the profile popup and try again.",
            "warning"
          );
        } else {
          const saveRes = await fetch(`${api_url}/users/${userId}`, {
            method: "PATCH",
            headers: {
              'Authorization': `Bearer ${sessionData.accessToken}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ profilePicture: imageURL })
          });
          let saveJson: any = null;
          try { saveJson = await saveRes.json(); } catch (e) {}

          if (!saveRes.ok) {
            const msg = saveJson?.message
              ? Array.isArray(saveJson.message) ? saveJson.message.join(", ") : String(saveJson.message)
              : saveJson?.error
              ? String(saveJson.error)
              : "Image uploaded, but could not be saved to your profile.";
            userNotification("Upload warning", msg, "warning");
          } else {
            const updatedUser = saveJson?.user_data || saveJson || {};
            const savedProfilePicture = String(updatedUser?.profilePicture || imageURL);
            const savedSignedUrl = String(
              updatedUser?.profilePictureSignedUrl || imageURLSigned || savedProfilePicture
            );
            setProfileDraft(prev => ({
              ...prev,
              profilePicture: savedProfilePicture,
              profilePictureSignedUrl: savedSignedUrl,
            }));
            setProfileOriginal(prev => prev ? {
              ...prev,
              profilePicture: savedProfilePicture,
              profilePictureSignedUrl: savedSignedUrl,
            } : prev);
            setProfileOverride(prev => ({
              ...prev,
              profilePicture: savedProfilePicture,
              profilePictureSignedUrl: savedSignedUrl,
            }));
            setProfileMe(prev => prev ? {
              ...prev,
              user_data: {
                ...prev.user_data,
                ...updatedUser,
                profilePicture: savedProfilePicture,
                profilePictureSignedUrl: savedSignedUrl,
              },
            } : prev);
          }
        }
      } else {
        userNotification("Upload error", "Upload response did not include an image URL.", "error");
      }
      setUploadInProgress(false)
    }

    const deleteProfilePicture = async() =>{
      setProfileDraft(prev => ({ ...prev, profilePicture: "", profilePictureSignedUrl: "" }));
    }

    const isProfileDirty = (() => {
      if (!profileOriginal) return false;
      if (profileDraft.username !== profileOriginal.username) return true;
      if (profileDraft.profilePicture !== profileOriginal.profilePicture) return true;
      if (profileDraft.notificationSettingsKey !== profileOriginal.notificationSettingsKey) return true;
      const a = profileDraft.notificationSettings;
      const b = profileOriginal.notificationSettings;
      if (!!a !== !!b) return true;
      if (a && b) {
        if (a.channels.inApp !== b.channels.inApp) return true;
        if (a.channels.email !== b.channels.email) return true;
        const mapA: Record<string, { inApp: boolean; email: boolean }> = {};
        const mapB: Record<string, { inApp: boolean; email: boolean }> = {};
        for (let i = 0; i < a.events.length; i++) mapA[a.events[i].key] = a.events[i].channels;
        for (let i = 0; i < b.events.length; i++) mapB[b.events[i].key] = b.events[i].channels;
        const keys = Object.keys({ ...mapA, ...mapB });
        for (let i = 0; i < keys.length; i++) {
          const k = keys[i];
          const ca = mapA[k];
          const cb = mapB[k];
          if (!ca || !cb) return true;
          if (ca.inApp !== cb.inApp) return true;
          if (ca.email !== cb.email) return true;
        }
      }
      return false;
    })();

    const saveProfileDraft = async () => {
      if (!sessionData?.accessToken) return;
      if (!profileOriginal) return;
      setIsProfileSaving(true);

      const userId = profileMe?.user_data?._id || sessionData?.user_data?._id;
      if (!userId) {
        userNotification("Error", "Missing user id (please reopen the profile popup).", "error");
        setIsProfileSaving(false);
        return;
      }
      const patch: any = {
        username: profileDraft.username,
        profilePicture: profileDraft.profilePicture,
      };

      // Convert resolved notificationSettings array → notificationPreferences object for PATCH
      if (profileDraft.notificationSettings) {
        const eventsObj: Record<string, { email: boolean; inApp: boolean }> = {};
        for (const ev of profileDraft.notificationSettings.events) {
          eventsObj[ev.key] = { email: ev.channels.email, inApp: ev.channels.inApp };
        }
        patch.notificationPreferences = {
          channels: {
            email: profileDraft.notificationSettings.channels.email,
            inApp: profileDraft.notificationSettings.channels.inApp,
          },
          events: eventsObj,
        };
      }

      const doPatch = async (body: any) => {
        const res = await fetch(`${api_url}/users/${userId}`, {
          method: "PATCH",
          headers: {
            'Authorization': `Bearer ${sessionData.accessToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        });
        let json: any = null;
        try { json = await res.json(); } catch (e) {}
        return { res, json };
      };

      let { res, json } = await doPatch(patch);
      if (!res.ok) {
        const merged = { ...((profileMe?.user_data || sessionData.user_data || {}) as any), ...patch };
        const second = await doPatch(merged);
        res = second.res;
        json = second.json;
      }

      if (res.ok) {
        userNotification("Saved", "Your profile has been updated.", "success");
        setProfileOriginal(profileDraft);
        setProfileOverride({
          username: profileDraft.username,
          profilePicture: profileDraft.profilePicture,
          profilePictureSignedUrl: profileDraft.profilePictureSignedUrl,
        });
        // Refresh cached data; if server returned updated notificationSettings, update draft too
        const updatedUser = json?.user_data || json;
        if (updatedUser && typeof updatedUser === 'object' && updatedUser.notificationSettings) {
          const detected = detectNotificationSettings(updatedUser);
          if (detected.settings) {
            const refreshedDraft = { ...profileDraft, notificationSettingsKey: detected.key, notificationSettings: detected.settings };
            setProfileDraft(refreshedDraft);
            setProfileOriginal(refreshedDraft);
          }
          setProfileMe(prev => prev ? ({ ...prev, user_data: updatedUser }) : prev);
        } else {
          setProfileMe(prev => prev ? ({ ...prev, user_data: { ...(prev.user_data || {}), ...patch } }) : prev);
        }
        onUserClose();
      } else {
        const msg = (json && (json.message || json.error))
          ? (Array.isArray(json.message) ? json.message.join(", ") : String(json.message || json.error))
          : "Could not update profile.";
        userNotification("Error", msg, "error");
      }
      setIsProfileSaving(false);
    };
    
    const makeSubscription = async () =>{
    
        ReactGA.event({ category: 'Subscription', action: 'Open Buy Subscription Modal' });
        const fetchData = await fetch(`${api_url}/teams/subscribe/price_1N1Bg7Dbs3ThQfLD3rd3ksvx`, {
          method: "POST",
          headers: {
            'Authorization': `Bearer ${sessionData.accessToken}`,
            'Content-Type': 'application/json'
          }
        })
        const fetchDataJson = await fetchData.json();
        if("statusCode" in fetchDataJson){
        }else{ 
            window.location.href = fetchDataJson.url;
        }
    }

    React.useEffect(() => {
      // Early return if sessionData is not available
      if (!sessionData || !sessionData.user_data) {
        return;
      }

      let tabArrayTemp =[];
      if(sessionData["usage"] && (sessionData["usage"]["used"] >= sessionData["usage"]["limit"])){
        limitExceded = true;
      }

      let admin = sessionData.user_data?.role == "ADMIN";
      let rights = sessionData.rights || []; 
      
      // Dashboard is always first (index 0)
      if((admin || rights.includes("invoices"))){
        tabArrayTemp.push("/dashboard");
      }

      // Invoices/Rechnungen (index 1)
      if((admin || rights.includes("invoices"))){
        tabArrayTemp.push("/");
      }

      if((admin || rights.includes("travel-expenses"))){
        //tabArrayTemp.push("/?tabIndexMenu=1");
      }

      if((admin || rights.includes("statistics"))){
        tabArrayTemp.push("/analytics");
      }

      if((admin || rights.includes("invoices"))){
        tabArrayTemp.push("/transactions");
        tabArrayTemp.push("/booking-records");
      }

      if((admin || rights.includes("invoices"))){
        tabArrayTemp.push("/queue");
      }

      if((admin || rights.includes("invoices"))){
        tabArrayTemp.push("/suggestions");
      }

      if((admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types") || rights.includes("manage-creditors")) ){
        tabArrayTemp.push("/creditors");
      }

      if((admin || rights.includes("manage-clearing-accounts")) ){
        tabArrayTemp.push("/clearing-accounts");
      }

      if((admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types")) ){
        tabArrayTemp.push("/settings");
        tabArrayTemp.push("/settings/integrations/google-drive");
      }

      // Profile page — available to all authenticated users
      tabArrayTemp.push("/profile");

      // Export (separate page, shown under Settings section)
      if (rights.includes("export-data")) {
        tabArrayTemp.push("/export");
      }

      let tabIndexTemp = tabArrayTemp.findIndex(e => e == router.pathname);

      setTabIndex(tabIndexTemp);

      setTabArray(tabArrayTemp)


    }, [router.pathname, sessionData?.accessToken, sessionData?.user_data?._id, sessionData?.user_data?.role, (sessionData?.rights || []).join(",")])

    // Fetch pending suggestions count
    React.useEffect(() => {
      const fetchPendingSuggestionsCount = async () => {
        if (!sessionData?.accessToken) return;
        try {
          const response = await fetch(`${api_url}/suggestions/count`, {
            headers: {
              'Authorization': `Bearer ${sessionData.accessToken}`,
            },
          });
          if (response.ok) {
            const data = await response.json();
            setPendingSuggestionsCount(data.count || 0);
          }
        } catch (error) {
          console.error('Error fetching suggestions count:', error);
        }
      };
      
      fetchPendingSuggestionsCount();
      // Refresh count every 30 seconds
      const interval = setInterval(fetchPendingSuggestionsCount, 30000);
      return () => clearInterval(interval);
    }, [sessionData?.accessToken]);

    // Fetch unread notifications indicator (dot)
    React.useEffect(() => {
      const fetchUnreadNotifications = async () => {
        if (!sessionData?.accessToken) return;
        try {
          const params = new URLSearchParams({
            page: '1',
            pageSize: '1',
            status: 'unread',
          });

          const response = await fetch(`${api_url}/notifications?${params.toString()}`, {
            headers: {
              'Authorization': `Bearer ${sessionData.accessToken}`,
            },
          });

          if (response.ok) {
            const data = await response.json();
            const items = Array.isArray(data)
              ? data
              : (Array.isArray(data?.data) ? data.data : (Array.isArray(data?.notifications) ? data.notifications : []));
            setHasUnreadNotifications((items?.length || 0) > 0);
          }
        } catch (error) {
          console.error('Error fetching notifications:', error);
        }
      };

      fetchUnreadNotifications();
      const interval = setInterval(fetchUnreadNotifications, 30000);
      return () => clearInterval(interval);
    }, [sessionData?.accessToken]);

    let limitExceded = false; 
    
    // Add null safety checks for sessionData
    if(sessionData != undefined && !("usage" in sessionData)){
      window.location.href= `https://rekening.b2clogin.com/rekening.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1_APP_INTEGRATION_CONTENT_MICROSOFT_NEW&post_logout_redirect_uri=${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/auth/signout`
    }

    if(sessionData != undefined && sessionData["usage"] && (sessionData["usage"]["used"] >= sessionData["usage"]["limit"])){
      limitExceded = true;
    }

    // Add defensive null safety checks
    let admin = sessionData?.user_data?.role == "ADMIN";
    let rights = sessionData?.rights || []; 


    //SignUp Discount Timer

    // Erstelle ein Date-Objekt aus createdAt
    let countdownCreatedAt = new Date(); 
    try {
      if (sessionData?.team_data?.createdAt) {
        countdownCreatedAt = new Date(sessionData.team_data.createdAt); 
      }
    } catch (error) {
    }
    // Berechne die Endzeit des Countdowns (60 Minuten nach createdAt)
    const countdownEnd = countdownCreatedAt.getTime() + 60 * 60 * 1000 + 500000;
    // Aktuelle Zeit
    const countdownNow = new Date().getTime();
    // Berechne die vergangene Zeit in Millisekunden
    const countdownTimeElapsed = countdownNow - countdownCreatedAt.getTime();

    // Berechne verbleibende Zeit
    let countdownTimeLeft = countdownEnd - countdownNow;


    const menuElement = (
    <div>
      {/* Floating Side Menu */}
      <Box
        position="fixed"
        left="0"
        top="0"
        height="100vh"
        zIndex={1000}
        bg="white"
        boxShadow="lg"
        borderRadius="0 8px 8px 0"
        transition="all 0.3s ease"
        _hover={{
          width: "280px",
        }}
        width="80px"
        overflow="hidden"
        className="side-menu"
      >
        <VStack spacing={0} height="100%" align="stretch">
          {/* User Profile Section */}
          <Box p={4} borderBottom="1px solid" borderColor="gray.200" position="relative">
            <HStack spacing={3}>
              <Avatar 
                size="md" 
                src={
                  profileOverride.profilePictureSignedUrl ??
                  profileOverride.profilePicture ??
                  sessionData?.user_data?.profilePictureSignedUrl ??
                  sessionData?.user_data?.profilePicture
                } 
                name={profileOverride.username ?? sessionData?.user_data?.username}
                onClick={() => router.push('/profile')}
                cursor="pointer"
              />
              <Box className="side-menu-user-info">
                <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase">
                  {sessionData?.user_data?.role}
                </Text>
                <Text fontSize="sm" fontWeight="bold" noOfLines={1}>
                  {profileOverride.username ?? sessionData?.user_data?.username}
                </Text>
              </Box>
            </HStack>
          </Box>

          {/* Team Switcher */}
          {sessionData?.team_data?.name && (
            <Box px={3} py={2} borderBottom="1px solid" borderColor="gray.100">
              <TeamSwitcherDropdown
                teams={sessionData.teams || []}
                activeTeamName={sessionData.team_data?.name || ''}
                activeTeamId={sessionData.team_data?._id || ''}
                accessToken={sessionData.accessToken}
              />
            </Box>
          )}

          {/* Navigation Menu */}
          <VStack spacing={0} flex={1} align="stretch">
            {/* Main Section */}
            <Box p={2} position="relative" mt={3} pt={6}>
              <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase" mb={1} px={2} className="side-menu-section-header">
                Main
              </Text>
              <VStack spacing={1} align="stretch">
                {(admin || rights.includes("invoices")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/dashboard")}
                    leftIcon={<IoGrid size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/dashboard") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/dashboard") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/dashboard") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.dashboard")}
                    </Text>
                  </Button>
                )}
                {(admin || rights.includes("invoices")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/")}
                    leftIcon={<IoReceipt size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.invoices")}
                    </Text>
                  </Button>
                )}
                {(admin || rights.includes("invoices")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/transactions")}
                    leftIcon={<IoSwapHorizontal size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/transactions") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/transactions") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/transactions") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.transactions")}
                    </Text>
                  </Button>
                )}

                {(admin || rights.includes("invoices")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/booking-records")}
                    leftIcon={<IoDocumentAttachOutline size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/booking-records") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/booking-records") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/booking-records") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="36px"
                    className="side-menu-button"
                    sx={{ pl: "10px" }}
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.bookingRecords")}
                    </Text>
                  </Button>
                )}

                {(admin || rights.includes("invoices")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/suggestions")}
                    leftIcon={<IoBulb size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/suggestions") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/suggestions") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/suggestions") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                    position="relative"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.suggestions")}
                    </Text>
                    {pendingSuggestionsCount > 0 && (
                      <Badge
                        colorScheme="red"
                        borderRadius="full"
                        position="absolute"
                        top="2px"
                        right="2px"
                        fontSize="xs"
                        minW="18px"
                        h="18px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        {pendingSuggestionsCount > 99 ? "99+" : pendingSuggestionsCount}
                      </Badge>
                    )}
                  </Button>
                )}

                {/* Notifications */}
                <Button
                  variant="ghost"
                  colorScheme="gray"
                  size="sm"
                  justifyContent="center"
                  onClick={() => navigateToTab("/notifications")}
                  leftIcon={<IoNotifications size={18} />}
                  _hover={{ bg: "gray.100" }}
                  _active={{ bg: isActiveRoute("/notifications") ? "rekening.500" : "gray.200" }}
                  bg={isActiveRoute("/notifications") ? "rekening.500" : "transparent"}
                  color={isActiveRoute("/notifications") ? "white" : "gray.700"}
                  borderRadius="md"
                  h="40px"
                  className="side-menu-button"
                  position="relative"
                >
                  <Text ml={2} fontWeight="medium" className="side-menu-text">
                    {t("components.menu.notifications")}
                  </Text>
                  {hasUnreadNotifications && (
                    <Box
                      position="absolute"
                      top="10px"
                      right="10px"
                      width="8px"
                      height="8px"
                      borderRadius="full"
                      bg="red.500"
                    />
                  )}
                </Button>

              </VStack>
            </Box>

            {/* Management Section */}
            <Box p={2} position="relative" pt={6}>
              <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase" mb={2} px={2} className="side-menu-section-header">
                Verwaltung
              </Text>
              <VStack spacing={1} align="stretch">
                {(admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types") || rights.includes("manage-creditors")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/creditors")}
                    leftIcon={<IoBusiness size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/creditors") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/creditors") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/creditors") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t('components.menu.tradingPartners')}
                    </Text>
                  </Button>
                )}

                {(admin || rights.includes("manage-clearing-accounts")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/clearing-accounts")}
                    leftIcon={<IoCash size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/clearing-accounts") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/clearing-accounts") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/clearing-accounts") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.clearingAccounts")}
                    </Text>
                  </Button>
                )}

                {(admin || rights.includes("statistics")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/analytics")}
                    leftIcon={<IoBarChart size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/analytics") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/analytics") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/analytics") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.analytics")}
                    </Text>
                  </Button>
                )}

                {(admin || rights.includes("invoices")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/queue")}
                    leftIcon={<IoTimer size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/queue") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/queue") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/queue") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.queue")}
                    </Text>
                  </Button>
                )}
              </VStack>
            </Box>

            {/* Settings Section */}
            <Box p={2} position="relative" pt={6}>
              <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase" mb={2} px={2} className="side-menu-section-header">
                Settings
              </Text>
              <VStack spacing={1} align="stretch">
                {(admin || rights.includes("manage-users") || rights.includes("manage-budgets") || rights.includes("manage-groups") || rights.includes("manage-invoice-types")) && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/settings")}
                    leftIcon={<IoSettings size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/settings") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/settings") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/settings") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.settings")}
                    </Text>
                  </Button>
                )}

                {rights.includes("export-data") && (
                  <Button
                    variant="ghost"
                    colorScheme="gray"
                    size="sm"
                    justifyContent="center"
                    onClick={() => navigateToTab("/export")}
                    leftIcon={<IoDownload size={18} />}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: isActiveRoute("/export") ? "rekening.500" : "gray.200" }}
                    bg={isActiveRoute("/export") ? "rekening.500" : "transparent"}
                    color={isActiveRoute("/export") ? "white" : "gray.700"}
                    borderRadius="md"
                    h="40px"
                    className="side-menu-button"
                  >
                    <Text ml={2} fontWeight="medium" className="side-menu-text">
                      {t("components.menu.export")}
                    </Text>
                  </Button>
                )}

              </VStack>
            </Box>
          </VStack>

          {/* Bottom Actions */}
          <VStack spacing={1} p={2} borderTop="1px solid" borderColor="gray.200">
            <Button
              variant="ghost"
              size="sm"
              justifyContent="center"
              onClick={() => onTutorialOpen()}
              leftIcon={<IoHelpCircle size={18} />}
              _hover={{ bg: "gray.50" }}
              borderRadius="md"
              h="40px"
              className="side-menu-button"
              colorScheme="gray.100"
            >
              <Text ml={2} fontWeight="medium" className="side-menu-text">
                Help
              </Text>
            </Button>
            {(admin || rights.includes("manage-users")) && (
              <Button
                variant="ghost"
                size="sm"
                justifyContent="center"
                onClick={() => onInviteUserOpen()}
                leftIcon={<IoPersonAdd size={18} />}
                _hover={{ bg: "gray.50" }}
                borderRadius="md"
                h="40px"
                className="side-menu-button"
                colorScheme="gray.100"
              >
                <Text ml={2} fontWeight="medium" className="side-menu-text">
                  Invite User
                </Text>
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              justifyContent="center"
              onClick={() => {
                window.location.href = `https://rekening.b2clogin.com/rekening.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1_APP_INTEGRATION_CONTENT_MICROSOFT_NEW&post_logout_redirect_uri=${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/auth/signout`
              }}
              leftIcon={<IoExit size={18} />}
              colorScheme="red"
              _hover={{ bg: "red.50" }}
              borderRadius="md"
              h="40px"
              className="side-menu-button"
            >
              <Text ml={2} fontWeight="medium" color="red.500" className="side-menu-text">
                Sign Out
              </Text>
            </Button>
          </VStack>
        </VStack>
      </Box>

      {/* Quick Action Buttons - Floating */}
      <Box
        position="fixed"
        top="20px"
        right="20px"
        zIndex={999}
      >
        <VStack spacing={2}>
          {/*(router.pathname == "/?tabIndexMenu=0" || router.pathname == "/") && limitExceded != true && (
            <Tooltip label={t("components.menu.addInvoice")} placement="left">
              <IconButton
                colorScheme="rekening"
                icon={<IoReceipt />}
                onClick={() => {openInvoice("invoice");ReactGA.event({ category: 'Invoice', action: 'Add Invoice' });}}
                aria-label="Add Invoice"
                size="lg"
                isRound
                boxShadow="lg"
              />
            </Tooltip>
          )}
          
          {(router.pathname == "/?tabIndexMenu=0" || router.pathname == "/") && (rights.includes("travel-expenses")) && limitExceded != true && (
            <Tooltip label={t("components.menu.addTravelExpense")} placement="left">
              <IconButton
                colorScheme="rekening"
                icon={<IoEarth />}
                onClick={() => {openInvoice("travel-expense");ReactGA.event({ category: 'Invoice', action: 'Add Travel Expense' });}}
                aria-label="Add Travel Expense"
                size="lg"
                isRound
                boxShadow="lg"
              />
            </Tooltip>
          )}*/}


          {limitExceded && (
            <Tooltip label={t("components.menu.upgradePlan")} placement="left">
              <IconButton
                colorScheme="rekening"
                icon={<IoCart />}
                onClick={() => {onUpgradeOpen()}}
                aria-label="Upgrade Plan"
                size="lg"
                isRound
                boxShadow="lg"
              />
            </Tooltip>
          )}
        </VStack>
      </Box>

      {/* Subscription Banner */}
      {limitExceded == true && 
      <div className='subscription-banner' onClick={()=>{onUpgradeOpen()}}>
        <Text fontSize={"md"}>
          {t("components.menu.exededFreeUsage")}<br/>
          {t("components.menu.selectSubscriptionToContinue")}
        </Text>
        <Center mt="3">
          <IoCart fontSize={"22px"}></IoCart>
        </Center>
      </div>
      }

      <Modal isOpen={isUserOpne} onClose={onUserClose}>
        <ModalOverlay />
        <ModalContent>
          {sessionData != undefined && 
            <ModalHeader>
              Profile
            </ModalHeader>
          }
          <ModalCloseButton />
          {sessionData != undefined && 
            <ModalBody>
              <Box
                borderWidth="1px"
                borderRadius="lg"
                p={4}
                bg="gray.50"
                onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const file = e.dataTransfer?.files?.[0];
                  if (file) uploadProPic(file as any, false);
                }}
              >
                <HStack spacing={4} align="center">
                  <Avatar
                    borderRadius={12}
                    height="72px"
                    width="72px"
                    src={profileDraft.profilePictureSignedUrl || profileDraft.profilePicture || undefined}
                    name={profileDraft.username || sessionData?.user_data?.username}
                  />
                  <Box flex="1">
                    <Text fontWeight="bold" mb="1">{t("components.menu.uploadPicture")}</Text>
                    <Text fontSize="sm" color="gray.600" mb="2">
                      Drag & drop an image here, or click to choose a file.
                    </Text>
                    <HStack>
                      <Button
                        variant="outline"
                        onClick={() => (ProfilePictureUploadRef.current as any)?.click?.()}
                        isLoading={uploadInProgress}
                        leftIcon={<IoCloudUpload />}
                      >
                        Choose file
                      </Button>
                      <Button
                        variant="outline"
                        colorScheme="red"
                        onClick={deleteProfilePicture}
                        isDisabled={!profileDraft.profilePicture || uploadInProgress}
                        leftIcon={<IoTrash />}
                      >
                        Remove
                      </Button>
                      <input
                        ref={ProfilePictureUploadRef}
                        style={{display: "none"}}
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = (e.target as any)?.files?.[0];
                          if (file) uploadProPic(file, false);
                          (e.target as any).value = '';
                        }}
                      />
                    </HStack>
                  </Box>
                </HStack>
              </Box>
              <Box mt="4">
                <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>{t("components.menu.name")}</Text>
                <Input
                  placeholder='Type here...'
                  value={profileDraft.username}
                  onChange={(e) => setProfileDraft(prev => ({ ...prev, username: e.target.value }))}
                  isDisabled={isProfileLoading}
                />
              </Box> 
              <Box mt="2">
                <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>Team</Text>
                <Input
                  placeholder='Type here...'
                  value={profileMe?.team_data?.name || sessionData?.team_data?.name || ""}
                  readOnly={true}
                />
              </Box> 
              <Box mt="2">
                <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>E-Mail</Text>
                <Input
                  placeholder='Type here...'
                  value={profileMe?.user_data?.email || sessionData?.user_data?.email || ""}
                  readOnly={true}
                />
              </Box> 

              <Box mt="4" borderWidth="1px" borderRadius="lg" p={4}>
                <Text fontWeight="bold" mb="1">Benachrichtigungseinstellungen</Text>
                {profileDraft.notificationSettingsKey && profileDraft.notificationSettings ? (
                  <Box>
                    <Text fontSize="sm" color="gray.600" mb="3">
                      Lege fest, welche Benachrichtigungen du in der App und per E-Mail bekommen moechtest.
                    </Text>

                    {/* Global channels */}
                    <Box mb="4" p="3" borderWidth="1px" borderRadius="md" bg="white">
                      <HStack justify="space-between" align="start">
                        <Box>
                          <Text fontSize="sm" fontWeight="bold">Benachrichtigungen erhalten</Text>
                          <Text fontSize="xs" color="gray.500">
                            Wenn ein Kanal ausgeschaltet ist, werden die Themen darunter fuer diesen Kanal deaktiviert.
                          </Text>
                        </Box>
                        <HStack spacing={6}>
                          <Checkbox
                            isChecked={!!profileDraft.notificationSettings.channels.inApp}
                            isDisabled={isProfileLoading}
                            onChange={(e) =>
                              setProfileDraft(prev => ({
                                ...prev,
                                notificationSettings: prev.notificationSettings
                                  ? {
                                      ...prev.notificationSettings,
                                      channels: { ...prev.notificationSettings.channels, inApp: e.target.checked },
                                    }
                                  : prev.notificationSettings,
                              }))
                            }
                          >
                            App
                          </Checkbox>
                          <Checkbox
                            isChecked={!!profileDraft.notificationSettings.channels.email}
                            isDisabled={isProfileLoading}
                            onChange={(e) =>
                              setProfileDraft(prev => ({
                                ...prev,
                                notificationSettings: prev.notificationSettings
                                  ? {
                                      ...prev.notificationSettings,
                                      channels: { ...prev.notificationSettings.channels, email: e.target.checked },
                                    }
                                  : prev.notificationSettings,
                              }))
                            }
                          >
                            E-Mail
                          </Checkbox>
                        </HStack>
                      </HStack>
                    </Box>

                    {/* Topics list */}
                    <VStack align="stretch" spacing={2}>
                      <HStack justify="space-between" px="2">
                        <Box>
                          <Text fontSize="xs" color="gray.500" fontWeight="bold">THEMA</Text>
                        </Box>
                        <HStack spacing={10}>
                          <Text fontSize="xs" color="gray.500" fontWeight="bold">APP</Text>
                          <Text fontSize="xs" color="gray.500" fontWeight="bold">E-MAIL</Text>
                        </HStack>
                      </HStack>

                      {profileDraft.notificationSettings.events.map((ev) => {
                        const appTopicsDisabled =
                          isProfileLoading || !profileDraft.notificationSettings?.channels.inApp;
                        const emailTopicsDisabled =
                          isProfileLoading || !profileDraft.notificationSettings?.channels.email;
                        const allTopicsDisabled = appTopicsDisabled && emailTopicsDisabled;
                        return (
                          <Box
                            key={ev.key}
                            p="3"
                            borderWidth="1px"
                            borderRadius="md"
                            bg={allTopicsDisabled ? "gray.50" : "white"}
                            opacity={allTopicsDisabled ? 0.58 : 1}
                          >
                            <HStack justify="space-between" align="start">
                              <Box pr="4">
                                <Text fontSize="sm" fontWeight="bold">{ev.label || ev.key}</Text>
                                {ev.description && (
                                  <Text fontSize="xs" color="gray.500">{ev.description}</Text>
                                )}
                                <Text fontSize="xs" color="gray.400" mt="1">Key: {ev.key}</Text>
                              </Box>
                              <HStack spacing={10} pt="1">
                                <Checkbox
                                  isChecked={!!ev.channels.inApp}
                                  isDisabled={appTopicsDisabled}
                                  onChange={(e) =>
                                    setProfileDraft(prev => ({
                                      ...prev,
                                      notificationSettings: prev.notificationSettings
                                        ? {
                                            ...prev.notificationSettings,
                                            events: prev.notificationSettings.events.map((x) =>
                                              x.key === ev.key
                                                ? { ...x, channels: { ...x.channels, inApp: e.target.checked } }
                                                : x
                                            ),
                                          }
                                        : prev.notificationSettings,
                                    }))
                                  }
                                />
                                <Checkbox
                                  isChecked={!!ev.channels.email}
                                  isDisabled={emailTopicsDisabled}
                                  onChange={(e) =>
                                    setProfileDraft(prev => ({
                                      ...prev,
                                      notificationSettings: prev.notificationSettings
                                        ? {
                                            ...prev.notificationSettings,
                                            events: prev.notificationSettings.events.map((x) =>
                                              x.key === ev.key
                                                ? { ...x, channels: { ...x.channels, email: e.target.checked } }
                                                : x
                                            ),
                                          }
                                        : prev.notificationSettings,
                                    }))
                                  }
                                />
                              </HStack>
                            </HStack>
                          </Box>
                        );
                      })}
                    </VStack>
                  </Box>
                ) : (
                  <Text fontSize="sm" color="gray.500">
                    No notification settings are available for this account yet.
                  </Text>
                )}
              </Box>
              
              {(admin || rights.includes("invite-users"))&&
              <Box mt="2">
                <Text fontSize={"smaller"} mb={"1"} fontWeight={"bold"}>{t("components.menu.inviteNewUser")}</Text>
                <Button width="full" mr="3" onClick={()=>{onOpen()}}>
                    <IoPersonAdd />
                    <Text ml="1">{t("components.menu.inviteUser")}</Text>
                </Button>
              </Box>
              }

              <Text fontSize={"0.8em"} color={"gray.500"} ml="0" mt="3">
                <a target="_blank" href="https://rekening.de/en-allgemeine-geschaftsbedingungen/">Terms of Use</a> | <a target="_blank" href="https://rekening.de/en-privacy-policy/">Privacy Policy</a> | {t("components.menu.deleteAccount")}
              </Text>
            </ModalBody>
          }

          <ModalFooter>
            <Button variant="outline" mr={3} onClick={()=>{window.location.href= `https://rekening.b2clogin.com/rekening.onmicrosoft.com/oauth2/v2.0/logout?p=B2C_1_APP_INTEGRATION_CONTENT_MICROSOFT_NEW&post_logout_redirect_uri=${process.env.NEXT_PUBLIC_NEXTAUTH_URL}/auth/signout`}}>
              <IoExit style={{marginRight: "5px"}} />{t("components.menu.signOut")}
            </Button>
            <Button onClick={onUserClose} variant="ghost" mr={3}>Cancel</Button>
            <Button
              colorScheme="rekening"
              leftIcon={<IoSave />}
              onClick={saveProfileDraft}
              isLoading={isProfileSaving}
              isDisabled={!isProfileDirty || !profileDraft.username}
            >
              Save changes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <TutorialModal isOpen={isTutorialOpen} onClose={onTutorialClose}/>
      <InviteUserModal isOpen={isInviteUserOpen} onClose={onInviteUserClose} session={sessionData} />

      {countdownTimeLeft > 0 &&
      isSignupDiscountVisible &&
      <div className="signup-discount-container">
        <IconButton
          className="signup-discount-close"
          aria-label={t("close")}
          variant="ghost"
          color="white"
          icon={<IoCloseCircle />}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsSignupDiscountVisible(false);
          }}
        />
        <Center>
          <Heading size="md" color={"white"} mt="2">
            <Countdown
              date={countdownEnd}
              renderer={rendererTimer}
              onComplete={()=>{countdownTimeLeft = 0}}
            />
          </Heading>
          </Center>
          <Center>
            <Heading size="sm" color={"white"} style={{ display: 'inline' }}>
            {t("components.menu.discount90")}
            </Heading>
            <Heading size="sm" color={"white"} style={{display:"inline", marginLeft: "7px", marginRight: "7px", textDecoration: "underline",textDecorationStyle: "dotted"}}>
              SIGNUP90
            <IoCopy style={{display:"inline", fontSize: "14", marginLeft: "2px", cursor:"pointer"}} onClick={()=>{
                navigator.clipboard.writeText("SIGNUP90")
                .then(() => {
                  userNotification(t("components.menu.copiedClipboard"),t("components.menu.successfullyCopied"),"success")
                })
                .catch(err => {
                  console.error(t("components.menu.copyError"), err);
                })
              }
              }></IoCopy>
            </Heading>
            <Heading color={"white"} size="sm" style={{ display: 'inline' }}>
              {t("components.menu.atCheckout")}
            </Heading>
          </Center>
          <Center>
            <Button mt="3" onClick={()=>{makeSubscription();ReactGA.event({ category: 'Subscription', action: 'Claim Discount' });}}>{t("components.menu.claimDiscountNow")}<IoCaretForward></IoCaretForward> </Button>
          </Center>
      </div>
      }
    </div>
  );
  
  return menuElement;
};

export default MenuElement;